import { render, staticRenderFns } from "./PricingFormV1.vue?vue&type=template&id=27f84800&scoped=true&"
import script from "./PricingFormV1.vue?vue&type=script&lang=js&"
export * from "./PricingFormV1.vue?vue&type=script&lang=js&"
import style0 from "./PricingFormV1.vue?vue&type=style&index=0&id=27f84800&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f84800",
  null
  
)

export default component.exports